<template>
  <div id="AnalyzeInvoiceSettlement" class="full-height">
   <crud-layout
      ref="crudLayout"
      :name="name"
      :id="id"
      :pageDetail="pageDetail">
   </crud-layout>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import AnalyzeInvoiceSettlementDetail from './AnalyzeInvoiceSettlementDetail.vue'
import AnalyzeInvoiceSettlementTable from './AnalyzeInvoiceSettlementTable.vue'
import { repository } from 'jtech'

const { CrudLayout, CrudLayoutSearch } = JtCrud
const INTERFACE_NAMES = {
  LOAD_INVOICE_SETTLEMENT: 'analyzeInvoiceSettlement.pesquisar',
  DETAIL_EXEMPT_ORDER: 'analyzeInvoiceSettlement.detalhar',
  APPROVE_EXEMPTION: 'analyzeInvoiceSettlement.approval',
  DENY_EXEMPTION: 'analyzeInvoiceSettlement.disapprove',
  ALTER_EXEMPTION: 'analyzeInvoiceSettlement.alterar'
}

const createErrorMessages = (vm) => ({
  LOAD_ERROR: vm.$gettext('ERROR_LOADING_DATA'),
  LOAD_DATATABLE_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE'),
  LOAD_DATATABLE_MODEL_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE_MODEL'),
  ACTION_ERROR: vm.$gettext('ERROR_EXECUTING_ACTION'),
  DETAIL_ERROR: vm.$gettext('ERROR_DETAIL_RECORD')
})

@Component({
  name: 'AnalyzeInvoiceSettlement',
  components: {
    CrudLayout,
    AnalyzeInvoiceSettlementTable,
    AnalyzeInvoiceSettlementDetail
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})

class AnalyzeInvoiceSettlement extends Vue {
  static INTERFACE_NAMES = INTERFACE_NAMES

  data = null;
  datatable = null;

  ERROR_MESSAGES = null;

  created () {
    this.ERROR_MESSAGES = createErrorMessages(this)
  }

  async mounted () {
    try {
      if (this.$refs.crudLayout.state.containers[this.id]) return
      const forms2 = await repository.resolve(this.interface, {})
      const datatable = await repository.resolveDatatable(this.interface)
      const dadosForm = forms2[0].dadosForm
      this.$refs.crudLayout.addPage({
        name: 'approvation_page',
        label: this.$gettext('APPROVAL_CONTRO'),
        params: { ...dadosForm, crudLayout: this.$refs.crudLayout },
        datatable: datatable,
        component: AnalyzeInvoiceSettlementTable,
        flClose: false,
        forms: forms2
      })
    } catch (error) {
      console.error(error)
    }
  }

  get nmInterface () {
    return this.interface
  }

  get pageTable () {
    return AnalyzeInvoiceSettlementTable
  }

  get pageDetail () {
    return AnalyzeInvoiceSettlementDetail
  }
}

export default AnalyzeInvoiceSettlement
</script>

<style scoped>
@import "tailwindcss/utilities";
.table-header {
  position: fixed;
  top: 0;
  z-index: 10;
}

.cell-values {
  display: flex;
  flex-direction: column;
}

.table {
  margin-top: 140px;
}

.buttons-area {
  height: 55px;
  display: flex;
}

.index-table {
  width: 45%;
  margin-left: 16px;
}

.rigth-buttons {
  width: 55%;
  display: flex;
  justify-content: flex-end;
}

.sub-teble-btn {
  color: #555;
}

.top-area {
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
